// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vC0P0IVOsUM0Iy8oEBLD {
  position: relative;
  display: flex;
  padding: 12px;
  border-radius: 12px;
  transition: background 0.2s;
}
@media only screen and (max-width: 767px) {
  .vC0P0IVOsUM0Iy8oEBLD {
    padding: 0;
    border-radius: 0;
  }
}
@media only screen and (min-width: 768px) {
  .vC0P0IVOsUM0Iy8oEBLD:hover {
    background: #F4F4F4;
  }
  .dark-mode .vC0P0IVOsUM0Iy8oEBLD:hover {
    background: #272B30;
  }
}
.vC0P0IVOsUM0Iy8oEBLD:after {
  content: "";
  position: absolute;
  top: 18px;
  right: 12px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #9A9FA5;
}
@media only screen and (max-width: 767px) {
  .vC0P0IVOsUM0Iy8oEBLD:after {
    display: none;
  }
}
.vC0P0IVOsUM0Iy8oEBLD.DNyUZHoWMNzqeqTy4p77:after {
  background: #2A85FF;
}
.vC0P0IVOsUM0Iy8oEBLD:not(:last-child) {
  margin-bottom: 41px;
}
@media only screen and (max-width: 767px) {
  .vC0P0IVOsUM0Iy8oEBLD:not(:last-child) {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #EFEFEF;
  }
  .dark-mode .vC0P0IVOsUM0Iy8oEBLD:not(:last-child) {
    border-color: #272B30;
  }
}
.vC0P0IVOsUM0Iy8oEBLD:not(:last-child):before {
  content: "";
  position: absolute;
  top: calc(100% + 20px);
  left: 12px;
  right: 12px;
  height: 1px;
  background: #EFEFEF;
}
@media only screen and (max-width: 767px) {
  .vC0P0IVOsUM0Iy8oEBLD:not(:last-child):before {
    display: none;
  }
}
.dark-mode .vC0P0IVOsUM0Iy8oEBLD:not(:last-child):before {
  background: #272B30;
}

.RfGT48Pr9501285qFbVU {
  position: relative;
  flex-shrink: 0;
  width: 64px;
  height: 64px;
}
.RfGT48Pr9501285qFbVU > img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.NLBdvvv4nd_ai4Z_VHgS {
  position: absolute;
  right: -2px;
  bottom: -2px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
}
.dark-mode .NLBdvvv4nd_ai4Z_VHgS {
  border-color: #1A1D1F;
}

.NLBdvvv4nd_ai4Z_VHgS img {
  width: 16px;
}

.z0WC9_WwbpLXHaKfJ6_a {
  flex: 0 0 calc(100% - 64px);
  width: calc(100% - 64px);
  padding-left: 12px;
}

.N5niD7hIO7GtP81VToM0 {
  display: flex;
  align-items: center;
  padding-right: 24px;
}

.y4wC6NeLSgHnoUXUMNqQ {
  margin-right: 4px;
  font-weight: 700;
  color: #1A1D1F;
  margin-right: auto;
}
.dark-mode .y4wC6NeLSgHnoUXUMNqQ {
  color: #FCFCFC;
}

.qoJm6V4TYSsm5F2HbBzU {
  margin-left: 16px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2307692308;
  color: #9A9FA5;
}

.xv5_3s7FgOGqEAlhArwW {
  margin-top: 8px;
  font-weight: 500;
}

.uxpTPrY9TutSMMVRs0qQ img {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/notification/List/Item/Item.module.sass","webpack://./src/styles/helpers.sass"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AADJ;ACUI;EDdJ;IAOQ,UAAA;IACA,gBAAA;EACN;AACF;AC2KI;ED5KA;IAEQ,mBC6BP;ED1BH;EC4KW;ID7KG,mBC+BX;ED3BH;AACF;AAJI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBC0BE;ADpBV;ACdI;EDAA;IAUQ,aAAA;EAQV;AACF;AAPQ;EACI,mBCCP;ADQL;AARI;EACI,mBAAA;AAUR;ACzBI;EDcA;IAGQ,mBAAA;IACA,oBAAA;IACA,gCAAA;EAYV;EC6IW;IDvJG,qBCSX;EDIH;AACF;AAbQ;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,mBCFP;ADiBL;AC5CI;EDsBI;IASQ,aAAA;EAiBd;AACF;AC2Ha;ED3IG,mBCHX;ADsBL;;AAjBA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAoBJ;AAnBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAqBR;;AAnBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAsBJ;AC8Fa;EDlHL,qBC3BH;ADkDL;;AAtBI;EACI,WAAA;AAyBR;;AAvBA;EACI,2BAAA;EACA,wBAAA;EACA,kBAAA;AA0BJ;;AAxBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AA2BJ;;AAzBA;EACI,iBAAA;EACA,gBAAA;EACA,cC5CC;ED6CD,kBAAA;AA4BJ;ACoEa;ED9FL,cCrDH;ADkFL;;AA1BA;EACI,iBAAA;ECYA,eAAA;EACA,gBAAA;EACA,yBAAA;EDZA,cClDM;ADiFV;;AA7BA;EACI,eAAA;EACA,gBAAA;AAgCJ;;AA7BI;EACI,eAAA;AAgCR","sourcesContent":["@import ../../../../styles/helpers\n\n.item\n    position: relative\n    display: flex\n    padding: 12px\n    border-radius: 12px\n    transition: background .2s\n    +m\n        padding: 0\n        border-radius: 0\n    &:hover\n        +rmin(768)\n            background: $n2\n            +dark\n                background: $n6\n    &:after\n        content: \"\"\n        position: absolute\n        top: 18px\n        right: 12px\n        width: 12px\n        height: 12px\n        border-radius: 50%\n        background: $shades1\n        +m\n            display: none\n    &.new\n        &:after\n            background: $p1\n    &:not(:last-child)\n        margin-bottom: 41px\n        +m\n            margin-bottom: 24px\n            padding-bottom: 24px\n            border-bottom: 1px solid $n3\n            +dark\n                border-color: $n6\n        &:before\n            content: \"\"\n            position: absolute\n            top: calc(100% + 20px)\n            left: 12px\n            right: 12px\n            height: 1px\n            background: $n3\n            +m\n                display: none\n            +dark\n                background: $n6\n\n.avatar\n    position: relative\n    flex-shrink: 0\n    width: 64px\n    height: 64px\n    & > img\n        width: 100%\n        height: 100%\n        border-radius: 50%\n        object-fit: cover\n\n.icon\n    position: absolute\n    right: -2px\n    bottom: -2px\n    display: flex\n    justify-content: center\n    align-items: center\n    width: 28px\n    height: 28px\n    border-radius: 50%\n    border: 2px solid $n\n    +dark\n        border-color: $n7\n    img\n        width: 16px\n\n.details\n    flex: 0 0 calc(100% - 64px)\n    width: calc(100% - 64px)\n    padding-left: 12px\n\n.line\n    display: flex\n    align-items: center\n    padding-right: 24px\n\n.subtitle\n    margin-right: 4px\n    font-weight: 700\n    color: $n7\n    margin-right: auto\n    +dark\n        color: $n1\n\n\n.time\n    margin-left: 16px\n    +caption1\n    color: $shades1\n\n.comment\n    margin-top: 8px\n    font-weight: 500\n\n.content\n    img\n        max-width: 100%","@use \"sass:math\"\n\n// media queries\n=w\n    @media only screen and (max-width: \"1419px\")\n        @content\n=x\n    @media only screen and (max-width: \"1339px\")\n        @content\n=d\n    @media only screen and (max-width: \"1259px\")\n        @content\n=t\n    @media only screen and (max-width: \"1023px\")\n        @content\n=m\n    @media only screen and (max-width: \"767px\")\n        @content\n=a\n    @media only screen and (max-width: \"639px\")\n        @content\n=s\n    @media only screen and (max-width: \"474px\")\n        @content\n\n// fonts\n=inter\n    font-family: 'Inter', sans-serif\n\n// colors\n$p1: #2A85FF\n$p2: #83BF6E\n$p3: #FF6A55\n$p4: #8E59FF\n$s1: #FFBC99\n$s2: #CABDFF\n$s3: #B1E5FC\n$s4: #B5E4CA\n$s5: #FFD88D\n\n$n: #FFFFFF\n$n1: #FCFCFC\n$n2: #F4F4F4\n$n3: #EFEFEF\n$n4: #6F767E\n$n5: #33383F\n$n6: #272B30\n$n7: #1A1D1F\n$n8: #111315\n\n$shades1: #9A9FA5\n$shades2: #6F767E\n$shades3: rgba(#6F767E, .4)\n$shades4: rgba(#111315, .5)\n\n// typography\n=title1-s\n    font-size: 20px\n    font-weight: 600\n    line-height: math.div( 32 , 20 )\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title1-m\n    font-size: 20px\n    font-weight: 500\n    line-height: math.div(32,20)\n    letter-spacing: -.02em\n    +m\n        font-size: 18px\n\n=title2\n    font-size: 18px\n    line-height: math.div(24,18)\n    letter-spacing: -0.02em\n\n=base1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n\n=base1-b\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=base2\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=body1-m\n    font-size: 15px\n    font-weight: 500\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body1-s\n    font-size: 15px\n    font-weight: 600\n    line-height: math.div(24,15)\n    letter-spacing: -.015em\n\n=body2-s\n    font-size: 14px\n    font-weight: 600\n    line-height: math.div(24,14)\n\n=caption1\n    font-size: 13px\n    font-weight: 600\n    line-height: math.div(16,13)\n\n=caption1-m\n    font-size: 13px\n    font-weight: 500\n    line-height: math.div(16,13)\n\n=caption2\n    font-size: 12px\n    font-weight: 700\n    line-height: math.div(16,12)\n\n=caption2-m\n    font-size: 12px\n    font-weight: 500\n    line-height: 1\n\n=button1\n    font-size: 15px\n    font-weight: 700\n    line-height: math.div(24,15)\n\n=button2\n    font-size: 13px\n    font-weight: 700\n    line-height: math.div(24,13)\n    \n//triangle\n=arr($width, $height, $bg, $direction)\n    width: 0px\n    height: 0px\n    border-style: solid\n    @if $direction == t\n        border-width: 0 $width / 2 + px $height + px $width / 2 + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == r\n        border-width: $height / 2 + px 0 $height / 2 + px $width + px\n        border-color: transparent transparent transparent $bg\n    @if $direction == b\n        border-width: $height + px $width / 2 + px 0 $width / 2 + px\n        border-color: $bg transparent transparent transparent\n    @if $direction == l\n        border-width: $height / 2 + px $width + px $height / 2 + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == tl\n        border-width: $height + px $width + px 0 0\n        border-color: $bg transparent transparent transparent\n    @if $direction == tr\n        border-width: 0 $width + px $height + px 0\n        border-color: transparent $bg transparent transparent\n    @if $direction == br\n        border-width: 0 0 $height + px $width + px\n        border-color: transparent transparent $bg transparent\n    @if $direction == bl\n        border-width: $width + px 0 0 $height + px\n        border-color: transparent transparent transparent $bg\n// example\n// +arr(500,50, #000, l)\n// +arr(500,50, #000, bl)\n\n// placeholder\n=placeholder\n    &::placeholder\n        @content\n\n// media query width\n=r($width)\n    @media only screen and (max-width: $width+ \"px\")\n        @content\n\n=rmin($width)\n    @media only screen and (min-width: $width+ \"px\")\n        @content\n\n// theme\n=dark\n    @at-root :global(.dark-mode) &\n        @content\n\n=dark-body\n    @at-root .dark-mode\n        @content\n\n=dark-common\n    @at-root .dark-mode &\n        @content"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `vC0P0IVOsUM0Iy8oEBLD`,
	"new": `DNyUZHoWMNzqeqTy4p77`,
	"avatar": `RfGT48Pr9501285qFbVU`,
	"icon": `NLBdvvv4nd_ai4Z_VHgS`,
	"details": `z0WC9_WwbpLXHaKfJ6_a`,
	"line": `N5niD7hIO7GtP81VToM0`,
	"subtitle": `y4wC6NeLSgHnoUXUMNqQ`,
	"time": `qoJm6V4TYSsm5F2HbBzU`,
	"comment": `xv5_3s7FgOGqEAlhArwW`,
	"content": `uxpTPrY9TutSMMVRs0qQ`
};
export default ___CSS_LOADER_EXPORT___;
